import { serviceLoading } from 'common/loaderReducer';
import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { RootState } from '../../../../../store/types';
import { WidgetContainer,WidgetTitle,InlineLeft,Info2,ToolTipContainer2,IconContainer,ToolTipLabel,EmptyStateContainer,EmptyStateMessage2 } from '../styles';
import ChartDoughnut from 'components/ChartDoughnut'
import info from '../../../../../common/images/icon-info.svg';
import { GET_PROFILE_PERFORMANCE_INSIGHTS_API_REQUEST } from 'features/Dealers/Performance/state/actionTypes';
import { ProfilePerformanceViewsStats } from 'features/Dealers/Performance/state/types';
import { ILegendItem } from 'components/ChartDoughnut/types';
import Loader from 'components/Loader';
import noprofileviews from './noprofileviews.png'
import { CalculatePercentageOfTotal, numberWithCommas, GetNumberKMG } from 'features/Dealers/Performance/Widgets/utils';

const WidgetProfileViews = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const colors = ['#FF7F27','#61BF7C'];

    const rootProps = useSelector((rootState: RootState) => {
        const isRequesting = serviceLoading(rootState, [GET_PROFILE_PERFORMANCE_INSIGHTS_API_REQUEST]);
        return {
            dealerId: rootState.dealers.dealer.selectedDealer?.id,
            viewsStats: rootState.dealers.offerInsights.profilePerformanceStats?.viewsStats,
            isRequesting
        }
    }, shallowEqual);

    const totalViews: number = (rootProps.viewsStats?.search?rootProps.viewsStats?.search:0) + (rootProps.viewsStats?.maps?rootProps.viewsStats?.maps:0);

    return (
        <WidgetContainer>
            <InlineLeft>
            <WidgetTitle>
                GBP Profile Views
            </WidgetTitle>
            <IconContainer>
            <Info2>
            <img src={info}></img>
            </Info2>
            <ToolTipContainer2>
                <ToolTipLabel>
                    Total views of your Business Profile and a breakdown
                    for the platform that people used to find your profile.
                </ToolTipLabel>
            </ToolTipContainer2>
            </IconContainer>
            </InlineLeft>
            {
                rootProps.isRequesting &&
                    <Loader/>
            }
            {
                !rootProps.isRequesting && totalViews>0 &&
                <ChartDoughnut
                    OuterRingData={GetData(rootProps.viewsStats,totalViews)}
                    OuterRingColors={colors}
                    OuterRingDataSpacer={5}
                    innerTextLine1={GetNumberKMG(totalViews)}
                    innerTextLine2={'VIEWS'}
                    ShowLegend={true}
                    LegendItems={GetLegendItems(colors,rootProps.viewsStats)}
                    OuterRingAnimation={true}
                    LegendPosition={window.innerWidth>2200?'RIGHT':'BOTTOM'}
                />
            }
            {
                !rootProps.isRequesting && totalViews===0 &&
                <EmptyStateContainer>
                    <img src={noprofileviews}/>
                    <EmptyStateMessage2>
                        No views on your GBP Profile. Once users start
                        looking at your profile you will see data about how
                        many customers found you via Google Search and 
                        Google Maps.
                    </EmptyStateMessage2>
                </EmptyStateContainer>
            }
        </WidgetContainer>
    )
}

function GetLegendItems(colors: string[],profilePerformanceViewsStats?:  ProfilePerformanceViewsStats)
{
    let legend: ILegendItem[] = [];
    if(profilePerformanceViewsStats)
    {
        legend.push({color:colors[0],label:'Google Search: ' + numberWithCommas((profilePerformanceViewsStats.search?profilePerformanceViewsStats.search:0).toString())});
        legend.push({color:colors[1],label:'Google Maps: ' + numberWithCommas((profilePerformanceViewsStats.maps?profilePerformanceViewsStats.maps:0).toString())});
    }
    return legend;
}

function GetData(profilePerformanceViewsStats?: ProfilePerformanceViewsStats,totalViews?: number)
{
    let data: number[] = [];
    if(profilePerformanceViewsStats)
    {
        data.push(CalculatePercentageOfTotal(profilePerformanceViewsStats.search?profilePerformanceViewsStats.search:0,totalViews));
        data.push(CalculatePercentageOfTotal(profilePerformanceViewsStats.maps?profilePerformanceViewsStats.maps:0,totalViews));
    }
    return data;
}

export default WidgetProfileViews
